'use client';

import { useMemo } from 'react';
import { ProductDetailLevel3, DocumentBlock } from '@workspace/widgets';
import { ContactSupportWrapper } from '@workspace/widgets';
import type { ProductDetailLevel3Data } from '@workspace/interfaces';

interface ProductDetailsClientProps {
  productData: ProductDetailLevel3Data;
}

export default function ProductDetailsClient({ productData }: ProductDetailsClientProps) {
  // Deduplicate attributeFilters by attribute._ref (keep first occurrence, which is from attributeConfigs)
  const deduplicatedProduct = useMemo(() => {
    if (!productData.attributeFilters?.length) return productData;

    const seen = new Set<string>();
    const uniqueFilters = productData.attributeFilters.filter((filter) => {
      if (seen.has(filter.attribute._ref)) return false;
      seen.add(filter.attribute._ref);
      return true;
    });

    return {
      ...productData,
      attributeFilters: uniqueFilters,
    };
  }, [productData]);

  return (
    <div className="min-h-screen">
      <ProductDetailLevel3 product={deduplicatedProduct} />
      {deduplicatedProduct.documentBlock && <DocumentBlock block={deduplicatedProduct.documentBlock} />}
      {productData.isIncludedContactSupport === true ? <ContactSupportWrapper docId={productData._id} /> : null}
    </div>
  );
}
